import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyDisplayService } from '../../_services/currency-display.service';
import { DataService } from '../../_services/data.service';
import { UserLocaleService } from '../../_services/user-locale.service';

@Pipe({
  name: 'inrdisplay'
})
export class InrdisplayPipe implements PipeTransform {

  constructor(
    private currencyDisplayService: CurrencyDisplayService,
    private dataService: DataService,
    private userLocaleService: UserLocaleService
  ) {
  }

  transform(value: any, currCode, args?: any): any {
    if (currCode) {
      return this.currencyDisplayService.getFormattedCurrencyStr({ amt: value, curr: currCode });
    } else {
      try {
        return this.userLocaleService.getLocaleFormattedAmount(value);  
      } catch (error) {
        return this.dataService.displayNumberAsCurrency(value);
      }
    }
    
  }

}
